import { DOCUMENT, inject, Injectable } from '@angular/core'

function removePotentialPathAndTrailingSlash(url: string) {
  // positive lookbehind -> must match a dot
  // 1st capturing group then is the tld
  // 2nd capturing group is the potential path and/or the trailing slash
  return url.replace(/(?<=\.)([a-z]+)(\/.+)$/, '$1')
}

@Injectable({ providedIn: 'root' })
export class PreconnectLinkService {
  private readonly doc: Document = inject(DOCUMENT)
  private readonly preconnnectedOrigins = new Set<string>()

  add(...urls: string[]) {
    urls.map(removePotentialPathAndTrailingSlash).forEach(this.addOrigin)
  }

  private readonly addOrigin = (origin: string) => {
    if (this.preconnnectedOrigins.has(origin)) {
      return
    }
    const linkEl = this.doc.createElement('link')
    linkEl.rel = 'preconnect'
    linkEl.href = origin
    this.doc.head.appendChild(linkEl)
  }
}
